export default "__VITE_ASSET__IDju0$Uf__"